import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '../../lib/utils';

const ROUTE_LABELS = {
  'dashboard': 'Dashboard',
  'operations': 'Opérations',
  'analytics': 'Analytique',
  'mes-contrats': 'Contrats',
  'mes-documents': 'Documents',
  'finances': 'Finances',
  'calendrier': 'Calendrier',
  'mes-incidents': 'Incidents',
  'suivi': 'Suivi temps réel',
  'messagerie': 'Messagerie',
  'notifications': 'Notifications',
  'mes-alertes': 'Alertes',
  'evaluations': 'Évaluations',
  'mon-compte': 'Mon Compte',
  'mes-rapports': 'Rapports',
  'configuration': 'Configuration',
  'nouvelle-demande': 'Nouvelle demande',
  'transferts': 'Transferts',
};

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-/i;

export const Breadcrumbs = ({ className }) => {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length <= 1) return null;

  const crumbs = segments
    .map((seg, i) => {
      const path = '/' + segments.slice(0, i + 1).join('/');
      const isLast = i === segments.length - 1;
      const label = ROUTE_LABELS[seg] || (UUID_RE.test(seg) ? null : decodeURIComponent(seg));
      return { path, label, isLast };
    })
    .filter(c => c.label !== null);

  return (
    <nav className={cn('flex items-center gap-1 text-sm text-gray-500 mb-4', className)} aria-label="Breadcrumb" data-testid="breadcrumbs">
      <Link to="/dashboard" className="hover:text-[#1db584] transition-colors flex items-center gap-1">
        <Home className="w-3.5 h-3.5" />
      </Link>
      {crumbs.map(({ path, label, isLast }) => (
        <React.Fragment key={path}>
          <ChevronRight className="w-3.5 h-3.5 text-gray-300" />
          {isLast ? (
            <span className="text-gray-800 font-medium" data-testid="breadcrumb-current">{label}</span>
          ) : (
            <Link to={path} className="hover:text-[#1db584] transition-colors">{label}</Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
